import { c as _c } from "react/compiler-runtime";
interface InstagramIconProps {
  color?: string;
  size?: number;
}
const InstagramIcon = t0 => {
  const $ = _c(9);
  const {
    color: t1,
    size: t2
  } = t0;
  const color = t1 === undefined ? "currentColor" : t1;
  const size = t2 === undefined ? 24 : t2;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  let t6;
  if ($[2] !== color) {
    t5 = <path d="M12.5931 23.2579L12.582 23.2599L12.511 23.2949L12.491 23.2989L12.477 23.2949L12.406 23.2599C12.3954 23.2566 12.3874 23.2583 12.382 23.2649L12.378 23.2749L12.361 23.7029L12.366 23.7229L12.376 23.7359L12.48 23.8099L12.495 23.8139L12.507 23.8099L12.611 23.7359L12.623 23.7199L12.627 23.7029L12.61 23.2759C12.6074 23.2653 12.6017 23.2593 12.5931 23.2579ZM12.858 23.1449L12.845 23.1469L12.66 23.2399L12.65 23.2499L12.647 23.2609L12.665 23.6909L12.67 23.7029L12.6781 23.7099L12.879 23.8029C12.8917 23.8063 12.9014 23.8036 12.908 23.7949L12.912 23.7809L12.878 23.1669C12.8747 23.1549 12.868 23.1476 12.858 23.1449ZM12.143 23.1469C12.1386 23.1443 12.1334 23.1434 12.1283 23.1445C12.1233 23.1456 12.1189 23.1487 12.116 23.1529L12.11 23.1669L12.076 23.7809C12.0767 23.7929 12.0824 23.8009 12.0931 23.8049L12.108 23.8029L12.309 23.7099L12.319 23.7019L12.323 23.6909L12.34 23.2609L12.337 23.2489L12.327 23.2389L12.143 23.1469Z" fill={color} />;
    t6 = <path d="M16 3C17.3261 3 18.5979 3.52678 19.5355 4.46447C20.4732 5.40215 21 6.67392 21 8V16C21 17.3261 20.4732 18.5979 19.5355 19.5355C18.5979 20.4732 17.3261 21 16 21H8C6.67392 21 5.40215 20.4732 4.46447 19.5355C3.52678 18.5979 3 17.3261 3 16V8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3H16ZM12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM16.5 6.5C16.2348 6.5 15.9804 6.60536 15.7929 6.79289C15.6054 6.98043 15.5 7.23478 15.5 7.5C15.5 7.76522 15.6054 8.01957 15.7929 8.20711C15.9804 8.39464 16.2348 8.5 16.5 8.5C16.7652 8.5 17.0196 8.39464 17.2071 8.20711C17.3946 8.01957 17.5 7.76522 17.5 7.5C17.5 7.23478 17.3946 6.98043 17.2071 6.79289C17.0196 6.60536 16.7652 6.5 16.5 6.5Z" fill={color} />;
    $[2] = color;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = <svg className="dynamic-size" style={t4} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">{t5}{t6}</svg>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default InstagramIcon;